import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";

import PatientTransformer from "@/Modules/Transformers/Patient";
import { get } from "@/Services/TherapyApi/Patients";

import useAppStore from "@/Modules/App/Store";
import useScheduleStore from "@/Modules/Schedule/Store";

import { danger } from "@/Utils/Debug";

async function getPatientsAH() {
  const scheduleStore = useScheduleStore();
  const appStore = useAppStore();

  scheduleStore.isLoadingPatients = true;

  try {
    const patientsApi = await get();

    scheduleStore.patients = patientsApi.map(PatientTransformer.toDomain);
  } catch (e) {
    danger(e);
    appStore.showSnackbar({
      type: NotificationType.ERROR,
      message: "there_was_an_error_connecting_to_the_server_please_try_again_later",
    });
  } finally {
    scheduleStore.isLoadingPatients = false;
  }
}

export default getPatientsAH;
